import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolToXAPDocHdrLineContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_to_xap_doc_hdr_line_container.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class PeppolToXAPDocHdrLineService extends BaseApiTemplateService<PeppolToXAPDocHdrLineContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'to-xap-docs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'to-xap-docs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'to-xap-docs/backoffice-ep'
    this.httpClient = http;
  }

  postToProcess(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    // Get the headers from getHttpHeader
    const httpOptions = this.getHttpHeader(visa);

    // Add the Content-Type header
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + Core2Config.PEPPOL_PREFIX + 'to-xap-docs/process-again/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      httpOptions
    );
  }
}
